import React, { useState, Component } from "react";
import { Link } from "react-router-dom";
import approvedStatus from "../../enums/ApprovedStatusTypes";
import { Tooltip } from 'reactstrap';


const StatusCell = (props) => {

        const dataItem = props.dataItem;

        const toolTip = (value) => {
            const [tooltipOpen, setTooltipOpen] = useState(false);
        
            const toggle = () => setTooltipOpen(!tooltipOpen);
            return(
                <Tooltip placement="right" isOpen={tooltipOpen} target={'TooltipExample' + dataItem.Id} toggle={toggle} className="timecard-tooltip">
                            <div>{value}</div>
                </Tooltip>
            )
        }

        return (
            <td id={'TooltipExample' + dataItem.Id}>
                {dataItem.ApprovedStatus === approvedStatus.Approved.value && 
                dataItem.DHApproved === false ? (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-red">&nbsp;</span> Approved – Billable</span>
                ) : null }
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value && 
                dataItem.DHApproved === false && (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-red">&nbsp;</span> Approved Non-Billable - General</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Approved.value && 
                dataItem.DHApproved === true && (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-light-green">&nbsp;</span> Approved – Billable</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value && 
                dataItem.DHApproved === true && (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-mid-blue">&nbsp;</span> Approved Non-Billable - General</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Pending_Approval.value && dataItem.IsSubmitted !== true && (
                    <span id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-none">&nbsp;</span> Not Submitted {dataItem.ResonOfMove !== null && (toolTip(dataItem.ResonOfMove))}
                    </span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Pending_Approval.value && dataItem.IsSubmitted === true && (
                    <span id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-teal">&nbsp;</span> Submitted - Approval Pending {dataItem.ResonOfMove !== null && (toolTip(dataItem.ResonOfMove))}
                    </span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Approved.value && 
                dataItem.DHApproved === null && (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-green">&nbsp;</span> Approved – Billable</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value &&
                dataItem.DHApproved === null &&
                dataItem.ApprovedNonBillingCatagoryId ===
                approvedStatus.Approved_NB_General.value ? (
                    <span id={'TooltipExample' + dataItem.Id}><span  className="timesheet-grid-status timesheet-grid-status-blue">&nbsp;</span> Approved Non-Billable - General</span>
                ) : null}
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value &&
                dataItem.DHApproved === null &&
                dataItem.ApprovedNonBillingCatagoryId ===
                approvedStatus.Approved_NB_ESE.value ? (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-yellow">&nbsp;</span> Approved Non-Billable - Estimation Issues</span>
                ) : null}
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value &&
                dataItem.DHApproved === null &&
                dataItem.ApprovedNonBillingCatagoryId ===
                approvedStatus.Approved_NB_PMM.value ? (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-purple">&nbsp;</span> Approved Non-Billable - Mismanagement</span>
                ) : null}
                {dataItem.ApprovedStatus === approvedStatus.Approved_NB.value &&
                dataItem.DHApproved === null &&
                dataItem.ApprovedNonBillingCatagoryId ===
                approvedStatus.Approved_NB_RWK.value ? (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-orange">&nbsp;</span> Approved Non-Billable - Rework</span>
                ) : null}
                {dataItem.ApprovedStatus === approvedStatus.Rejected.value && (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-gray">&nbsp;</span> Rejected {toolTip(dataItem.RejectReason)}</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Auto_Generated.value && (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-light-blue">&nbsp;</span> Automatic Approvals</span>
                )}
                {dataItem.ApprovedStatus === approvedStatus.Leave.value && (
                    <span  id={'TooltipExample' + dataItem.Id}><span className="timesheet-grid-status timesheet-grid-status-light-blue">&nbsp;</span> Leave</span>
                )}
                                {dataItem.ApprovedStatus === approvedStatus.Approved.value ||
                dataItem.ApprovedStatus === approvedStatus.Approved_NB.value ? (
                    toolTip("Approved By : " + dataItem.ApprovedBy + 
                        (dataItem.DHApproved === true ? "\nDelivery Head Approval Status : Approved" : "") + 
                        (dataItem.DHApproved === false ? "\nDelivery Head Approval Status : Rejected" : "") +
                        (dataItem.IsPMAddedTime === true ? "\nAutomatic Entry from PM-edited approval" : "")
                    )
                ) : null}
            </td>
        );
}

export default StatusCell;
